import React from "react";

import LocationsComponent from "./components/LocationsComponent/LocationsComponent";

const Locations: React.FC = () => {
  return <LocationsComponent />;
};

export default Locations;
